export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_06.bc1aab17.jpg";